export const MERCHANT_APPLY_BUSINESS_TYPE_LIST = {
  Medical: [
    { value: 'chiropractic', title: 'Chiropractic' },
    { value: 'cosmeticsurgery', title: 'Cosmetic Surgery' },
    { value: 'dental', title: 'Dental' },
    { value: 'medicaldevices', title: 'Medical Devices' },
    { value: 'veterinary', title: 'Veterinary' },
  ],
  Pet: [
    { value: 'petbreeder', title: 'Pet Breeder' },
    { value: 'petonline', title: 'Pet Online' },
    { value: 'petretail', title: 'Pet Retail' },
    { value: 'pettraining', title: 'Pet Training' },
    { value: 'veterinary', title: 'Veterinary' },
  ],
  Other: [
    { value: 'legal', title: 'Legal' },
    { value: 'sportinggoods', title: 'Sporting Goods' },
    { value: 'taxdebtrelief', title: 'Tax Debt Relief' },
  ],
};

export const MEDICAL_TOURISM_BUSINESS_TYPE_LIST = [
  { value: 'cosmeticsurgerytourism', title: 'Cosmetic Surgery' },
  { value: 'dentaltourism', title: 'Dental' },
];

export const MEDICAL_TOURISM_COUNTRIES_LIST = [
  { value: 'MX', title: 'Mexico' },
];
